export default function isUserSignedIn() {
  return !!(document.querySelector('body').className.match(/\buser-signed-in\b/));
}
